<div class="input-container">
    <p-multiSelect
        (onBlur)="blur($event)"
        (onFocus)="focus($event)"
        (mouseenter)="mouseEnter($event)"
        (mouseleave)="mouseLeave($event)"
        (ngModelChange)="onModelChange($event)"

        #popperError="popper"

        class="select-chips"
        display="chip"
        popperAppendTo="body"
        popperApplyClass="error"

        [ngModel]="value"
        [options]="simpleOptions$ | async"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [overlayOptions]="overlayOptions"
        [showClear]="showClear"
        [showHeader]="false"
        [placeholder]="placeholder"
        [disabled]="isDisabled"
        [tabindex]="tabIndex"
        [attr.tabindex]="tabIndex"
        [style.borderColor]="showErrorBorder && errorList?.length > 0 ? null : (overrideBorderColor ? overrideBorderColor : null)"
        [appendTo]="appendTo"

        [ngClass]="customClasses"
        [panelStyleClass]="panelClass"
        [class.has-error]="showErrorBorder && errorList?.length > 0"
        [class.is-disabled]="isDisabled"
        [class.is-readonly]="isReadonly"
        [class.is-multiline]="multiline ? multiline : null"
        [class.has-commands]="customCommandList?.length > 0"
        [maxSelectedLabels]="maxSelectedLabels"
        [popper]="tooltipErrTemplate"
        [popperDisabled]="!showErrorTooltip || !errorList || errorList?.length === 0"
        [popperTrigger]="ngxPopperjsTriggers.hover"
        [popperPlacement]="ngxPopperjsPlacements.TOP"
        [popperPreventOverflow]="false"
        [popperHideOnScroll]="true" />

    <div class="command-list-container"
        *ngIf="customCommandList?.length > 0"
        [class.is-disabled]="isDisabled">
        <ng-template ngFor let-command [ngForOf]="customCommandList">
            <nts-ribbon-button [title]="command.tooltip"
                [tabIndex]="0"
                [isLoading]="command.loading$ | async"
                [icon]="command.iconClass"
                [isDisabled]="!(command.canExecute$ | async)"
                (onClicked)="command.execute()">
            </nts-ribbon-button>
        </ng-template>
    </div>
</div>

<popper-content #tooltipErrTemplate>
    <ng-container *ngFor="let item of errorList">
        {{ item }}
    </ng-container>
</popper-content>